import { mapGetters, mapActions } from 'vuex'

import { DisplaySwitchButton } from '@/components/items'
import { storageUtil } from '@/util'

import ProductTable from './ProductTable'

export default {
  components: {
    DisplaySwitchButton,
    ProductTable
  },
  props: {
    storageType: {
      type: Array,
      default: () => []
    },
    historyProductMoves: {
      type: Array,
      require: false,
      default: () => []
    },
    isRegist: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    openPanelIndex: [],
    groupNames: [],
    pageProductList: [],
    productList: [],
    storageIdNameList: []
  }),
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions('Product', ['getProductAndStockListFromApi']),
    ...mapGetters('Product', ['getProductAndStockListFromState']),

    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),

    async init() {
      await this.createProductListData()
      this.setGroupNames()
    },
    getSupplierName(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier ? supplier.name : this.$t('common.common_unknown')
    },

    getSupplierIsEnabled(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier.isEnabled
    },

    async createProductListData() {
      const supplierId = null
      await this.getSuppliersFromApi()
      this.storageIdNameList = await storageUtil
        .getStorageIdNameList()
        .then((list) => list.data)
      await this.getProductAndStockListFromApi({
        supplierId: supplierId,
        isHideUnusedProduct: 1
      })
      const productList = this.getProductAndStockListFromState().filter(
        (ele) => {
          return this.getSupplierIsEnabled(ele.supplierId)
        }
      )
      this.productList = productList

      this.pageProductList = productList.map((ele) => {
        ele.supplierName = this.getSupplierName(ele.supplierId)
        ele.productInfo = ele.nameCn
          ? `${ele.nameJp}\n${ele.nameCn}`
          : `${ele.nameJp}`

        const storage = this.getStorageProductStockAndMoving(
          this.storageIdNameList,
          ele
        )
        const order = this.getProductQuantity(ele.productPlanQuantityInfo, 2)
        const sales = this.getProductQuantity(ele.productPlanQuantityInfo, 1)
        ele.order = order ? order : 0
        ele.sales = sales ? sales : 0
        ele.storage = storage
        return ele
      })
    },

    getHistoryProduct(productId) {
      this.historyProductMoves.find(
        (ele) => ele.product.productId === productId
      )
    },

    setGroupNames() {
      const productListTmp = [...this.productList]

      this.groupNames = productListTmp
        .sort((a, b) => {
          if (a.supplierId < b.supplierId) return -1
          if (a.supplierId > b.supplierId) return 1
          return 0
        })
        .reduce((result, current) => {
          var element = result.find((p) => p.groupId === current.supplierId)
          if (!element) {
            result.push({
              groupId: current.supplierId,
              open: false,
              index: result.length
            })
          }
          return result
        }, [])
    },
    isPanelOpen(id) {
      const group = this.groupNames.find((p) => p.groupId === id)
      return group ? group.open : false
    },

    getProductQuantity(productQuantity, transactionType) {
      const ret = productQuantity.reduce((result, current) => {
        if (
          !transactionType ||
          Number(current.transactionType) === transactionType
        ) {
          return result + current.quantity
        }
        return result
      }, 0)
      return ret
    },
    getStorageProductStockAndMoving(storageIdNameList, rec) {
      return storageIdNameList.map((ele) => {
        const stock = rec.productStockQuantityInfo.filter(
          (product) => ele.value === product.storageId
        )

        const moving = rec.productMovingQuantityInfo.filter(
          (product) => ele.value === product.storageId
        )

        return {
          id: ele.value,
          storageName: ele.label,
          stock: this.getProductQuantity(stock, null),
          moving: this.getProductQuantity(moving, null)
        }
      })
    },

    setGroupNamesOpen(newVal) {
      this.groupNames = this.groupNames.map((data, index) => {
        data.open = newVal.find((val) => val === data.index) !== undefined
        return data
      })
    }
  },
  computed: {
    headers() {
      const common = [
        {
          text: 'product.product_product-number',
          value: 'productNumber',
          sortable: false,
          width: '90px'
        },
        {
          text: 'common.product_product-name',
          value: 'productInfo',
          sortable: false,
          width: '250px'
        },
        {
          text: 'product.storage_ordered-and-undelivered-quantity',
          value: 'order',
          sortable: false,
          width: '120px'
        },
        {
          text: 'product.storage_ordered-unstocked-quantity',
          value: 'sales',
          sortable: false,
          width: '120px'
        }
      ]

      const optional = {}
      if (this.storageIdNameList.length > 0) {
        for (const storage of this.storageIdNameList) {
          optional[storage.value] = {
            text: storage.label,
            value: storage.value,
            sortable: false,
            width: '240px',
            children: [
              {
                text: 'storage.storage_stock-quantity',
                value: `stock_${storage.value}`,
                sortable: false,
                width: '120px'
              },
              {
                text: 'product.storage_transporting-from-another-warehouse',
                value: `moving_${storage.value}`,
                sortable: false,
                width: '120px'
              }
            ]
          }
        }
      }
      return [...common, ...this.storageType.map((id) => optional[id])]
    }
  },
  watch: {
    openPanelIndex: function (val) {
      this.setGroupNamesOpen(val)
    }
  }
}
